import React from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Avatar,
    Badge,
    Box,
    Button,
    Flex,
    Heading,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Select,
    Stack,
    Switch,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    WrapItem,
    useColorModeValue,
    useDisclosure,
    useToast
} from "@chakra-ui/react";
import { BsCheckSquareFill } from 'react-icons/bs'
import { AiFillMinusSquare } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import MyPagination from '../../../components/MyPagination'
import axiosClient from '../../../axios-client';

function SerieHistory() {
    const location = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [serie, setSerie] = useState([])
    const [paginationData, setPaginationData] = useState()
    const [checkLengthData, setCheckLengthData] = useState(false)

    // Pagination variables
    ////////////////////////////////the size of the table//////////////////////////////
    const [currentPage, setCurrentPage] = useState(0);
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    useEffect(() => {
        axiosClient
            .get(`/series/history/${location.state.serieId}/`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);
                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setSerie(filteredData);
                }
            })
    }, [pageSize, currentPage])




    return (
        <Box p={5}>
            <Flex>
                <Box w={"100%"} mt={3} mb={2}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>  / <span onClick={() => navigate('/series')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Liste des séries')}</span> / <span> {t('Historique de série')}</span></Text>
                </Box>

            </Flex>
            <Stack
                w={"full"}
                maxW="full"
                bg={useColorModeValue("white", "gray.700")}
                rounded={"lg"}
                p={6}
                my={5}
            >
                <TableContainer>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>Titre</Th>
                                <Th>Description</Th>
                                <Th>Image portrait</Th>
                                <Th>Image paysage</Th>
                                <Th>Date de modification</Th>
                                <Th>Modifié par</Th>
                            </Tr>
                        </Thead>
                        {(paginationData?.length !== 0) &&
                            serie?.map((val, key) => {
                                return (
                                    <Tbody>
                                        <Tr key={key}>
                                            <Td>
                                                {val.data.title === null ? <Text color='gray.400'>Non modifié</Text> : <Text fontWeight="semibold">
                                                    {val.data.title?.length > 20
                                                        ? `${val.data.title.substring(0, 20)}...`
                                                        : val.data.title}</Text>}
                                            </Td>
                                            <Td>
                                                {val.data.description === null ? <Text color='gray.400'>Non modifié</Text> : <Text fontWeight="semibold">
                                                    {val.data.description?.length > 20
                                                        ? `${val.data.description.substring(0, 20)}...`
                                                        : val.data.description}</Text>}
                                            </Td>
                                            <Td>{val.data.poster ? <Text fontWeight="semibold">Modifiée</Text> : <Text color='gray.400'>Non modifiée</Text>}</Td>
                                            <Td>{val.data.image ? <Text fontWeight="semibold">Modifiée</Text> : <Text color='gray.400'>Non modifiée</Text>}</Td>

                                            <Td>{new Date(val.edited_at).toLocaleString('fr-FR')}</Td>
                                            <Td><Text fontWeight="semibold">{val.edited_by}</Text></Td>
                                        </Tr>
                                    </Tbody>
                                )
                            })

                        }
                        {((paginationData?.length === 0) || (checkLengthData)) && (

                            <Tr>
                                <Td colSpan={11}>{t("Aucune modification n'a été apportée.")}</Td>
                            </Tr>
                        )}
                    </Table>
                </TableContainer>

                <Flex justify="space-between" align="center" w="100%">
                    <Box flex="1">
                        <MyPagination
                            paginationData={paginationData}
                            PAGE_SIZE={pageSize}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </Box>

                    <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        {/* Add more options as needed */}
                    </Select>
                </Flex>
            </Stack>
        </Box>
    )
}

export default SerieHistory